import React, { useState } from "react";
import Service from "../Service/http";
import { toast } from "react-toastify";
import { useQuery } from 'react-query';

const PreCollege = (props) => {
    const service = new Service();
    let [loading, SetLoading] = useState(false);
    const [collegeName, setCollegeName] = useState("");
    //hook to hide and display college list
    const [showColleges, setShowColleges] = useState(false);
    const toggleShowColleges = () =>{
        setShowColleges(!showColleges);
    }

    const addNewCollegeToDB = () => {
        SetLoading(true);
        service
            .post("api/addCollege", { college: collegeName })
            .then((json) => {
                SetLoading(false);
                toast.success("Created New College");
            })
            .catch((error) => {
                console.error(error);
                SetLoading(false);
                toast.error("error occured while adding college");
            });
    };

    const { data: collegeOptions, isError: collegeError, refetch: refetchColleges } = useQuery('colleges', () =>
        service.get('api/getColleges').then(response => response)
    );

    return (
        <div className="container">
            <div className="card mt-4">
                <h1 class=" text-center card-title text-primary mt-2">College Management</h1>
                <div className="form-group text-primary card-body">
                    <h5 class="card-title text-center">ADD NEW COLLEGE</h5>

                    <textarea
                        placeholder="Enter College Name"
                        className="form-control"
                        rows="1"
                        value={collegeName}
                        onChange={(e) => {
                            setCollegeName(e.target.value);
                        }}
                    ></textarea>
                </div>

                <div className="text-center">
                    <button
                        disabled={collegeName.length === 0}
                        onClick={() => {
                            addNewCollegeToDB();
                            setCollegeName("");
                            refetchColleges();
                        }}
                        className="btn btn-success m-2 mx-2 space-between"
                    >
                        ADD COLLEGE
                    </button>
                </div>
            </div>
            <div className="text-center mt-2">

            <button className="btn btn-success m-2 mx-2 space-between" onClick={toggleShowColleges}> {!showColleges ? "Show College List" :'Hide Colleges' } </button>
            </div>
            <br />
            {/* <div> */}
            {(showColleges && 
            <div className="text-center">
                <h1>Active colleges</h1>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>College Name</th>
                                <th>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {collegeOptions && collegeOptions?.data?.map((ele, ind) => (
                                <tr key={ind}>
                                    <td>{ele.college_name}</td>
                                    <td>{new Date(ele.createdAt).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
            </div>
            )}

            {/* </div> */}


        </div>
    );
};

export default PreCollege;

